import { api } from "../helper/apiClient.js";

function getToken() {
  try {
    return JSON.parse(sessionStorage.getItem("user") || "null")?.token ?? null;
  } catch {
    return null;
  }
}

export default async function statusServer(opts = {}) {
  const { force, ...rest } = opts || {};
  const token = rest.token ?? getToken();
  const qs = typeof force !== "undefined" ? `?force=${Boolean(force)}` : "";

  const raw = await api(`/status/servers${qs}`, { method: "GET", token, ...rest });
  // Alguns clients retornam { data: ... }; outros retornam o payload direto
  const data = raw?.data ?? raw;

  // Aceita vários formatos possíveis
  const list =
    Array.isArray(data?.servidores) ? data.servidores :
    Array.isArray(data?.servers)    ? data.servers    :
    Array.isArray(data?.items)      ? data.items      :
    Array.isArray(data)             ? data            : [];

  // Normalização de campos (cobre variações comuns)
  const normalize = (s = {}) => {
    const onlineBool =
      typeof s.online === "boolean" ? s.online :
      typeof s.status === "string"  ? s.status.toLowerCase() === "online" :
      !!s.isOnline;

    return {
      id: s.id ?? s._id ?? s.serverId ?? cryptoRandomId(),
      name: s.name ?? s.nome ?? s.hostname ?? s.app_url ?? "Servidor",
      app_url: s.app_url ?? s.host ?? s.fqdn ?? null,
      server_url: s.server_url ?? s.ip ?? s.address ?? null,
      online: onlineBool,
      status: onlineBool ? "online" : "offline",
      error: s.error ?? s.error_message ?? s.message ?? null,
      responseTime: s.responseTime ?? s.latency ?? s.rtt ?? null,
      lastCheck: s.lastCheck ?? s.timestamp ?? s.checkedAt ?? s.updatedAt ?? null,
    };
  };

  const servidores = list.map(normalize);

  // lastCheck do payload, ou derive do mais recente
  const lastCheck =
    data?.lastCheck ??
    (servidores.length
      ? servidores
          .map((s) => (s.lastCheck ? new Date(s.lastCheck).getTime() : 0))
          .reduce((a, b) => Math.max(a, b), 0) || null
      : null);

  return { servidores, lastCheck };
}

// Util para id quando não vier do backend
function cryptoRandomId() {
  try {
    // Navegadores modernos
    return crypto.randomUUID();
  } catch {
    // Fallback
    return `tmp_${Math.random().toString(36).slice(2, 10)}`;
  }
}

export async function estatisticaServer(opts = {}) {
  const token = opts.token ?? getToken();
  const raw = await api("/status/statistics", { method: "GET", token, ...opts });
  return raw?.data ?? raw;
}

export async function forcarVerificacao(body = {}, opts = {}) {
  const token = opts.token ?? getToken();
  const raw = await api("/status/check-now", { method: "POST", body, token, ...opts });
  return raw?.data ?? raw;
}
